<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div id="toolMain">
          <v-card id="toolsCard">
            <v-card-title
              id="tableTitle"
              class="primary--text"
              style="font-size: 1.5em; padding: 20px"
              >{{ $t('nav.tools') }}</v-card-title
            >
            <v-data-table
              id="toolTable"
              :headers="headers"
              :items="items"
              :items-per-page="-1"  
              class="elevation-0"
            >
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="text-align: left">{{ props.item.toolCode }}</td>
                  <td style="text-align: left">{{ props.item.description }}</td>
                  <td style="text-align: center">
                    <v-btn
                      id="btnDel"
                      color="primary"
                      x-small
                      fab
                      outlined
                      elevation="1"
                      @click="deleteItemConfirm(props.item)"
                    >
                      <v-icon small color="primary">
                        mdi-delete
                      </v-icon> </v-btn
                    >&nbsp;
                    <v-btn
                      id="btnEdit"
                      color="primary"
                      x-small
                      fab
                      outlined
                      elevation="1"
                      :disabled="props.item.isDeleted"
                      @click="editItem(props.item)"
                    >
                      <v-icon small color="primary"> mdi-pencil </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-dialog v-model="dialog" max-width="600px">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-form @submit.prevent="submit" ref="form">
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="editedItem.toolCode"
                            :rules="[
                              () => !!editedItem.toolCode || requiredMessage
                            ]"
                            required
                          >
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t('nav.toolId') }}
                            </template></v-text-field
                          >
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            v-model="editedItem.description"
                            :rules="[
                              () => !!editedItem.description || requiredMessage
                            ]"
                            required
                          >
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t('column.description') }}
                            </template></v-text-field
                          >
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close">{{
                    $t('common.cancel')
                  }}</v-btn>
                  <v-btn
                    color="primary"
                    :disabled="!formIsValid"
                    text
                    type="submit"
                    @click="save"
                    >{{ $t('common.save') }}</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-card-actions id="pCardAct">
              <v-btn
                id="btnAddtool"
                color="primary"
                dark
                small
                left
                fab
                @click="createItem()"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      dialog: false,
      requiredMessage: this.$t('common.required'),
      headers: [
        {
          text: this.$t('nav.toolId'),
          align: 'left',
          sortable: true,
          value: 'toolCode',
          width: '15%'
        },
        {
          text: this.$t('column.description'),
          align: 'left',
          value: 'description'
        },
        {
          text: this.$t('column.actions'),
          align: 'center',
          value: 'toolsactions',
          width: '20%',
          sortable: false
        }
      ],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      maxCode: ''
    }
  },
  computed: {
    ...mapGetters(['m_tool/getNextSeqCode', 'm_tool/getTools']),
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('common.new') + ' ' + this.$t('nav.tool')
        : this.$t('common.edit') + ' ' + this.$t('nav.tool')
    },

    items() {
      return this['m_tool/getTools']
    },

    formIsValid() {
      return this.editedItem.toolCode && this.editedItem.description
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this['m_tool/fetchNextMaxCode']();
    this['m_tool/fetchTools']()
  },

  methods: {
    ...mapMutations(['mHideLongLoader']),
    ...mapActions([
      'm_tool/createTool',

      'm_tool/fetchNextMaxCode',
      'm_tool/fetchTools',
      
      'm_tool/updateTool',
      'm_tool/deleteTool'
    ]),

    resetEntity(item) {
      this.editedIndex = item ? this.items.indexOf(item) : -1
      this.editedItem = Object.assign({}, item || this.defaultItem)
    },

    editItem(item) {
      this.resetEntity(item)
      this.dialog = true
    },

    createItem() {
      this.resetEntity()
      this.editedItem.toolCode = this['m_tool/getNextSeqCode']
      this.dialog = true
    },

    deleteItemConfirm(item) {
      this.resetEntity(item)

      var msg
      if (this.editedItem.isDeleted === false) {
        msg = 'warming.lock'
      } else {
        msg = 'warming.unlock'
      }

      this.$confirm(this.$t(msg) + this.$t('nav.tool') + '?', {
        buttonTrueText: this.$t('common.ok'),
        buttonFalseText: this.$t('common.cancel'),
        color: 'warning',
        icon: 'warning',
        title: this.$t('common.warning'),
        width: 350,
        property: '$confirm'
      }).then((res) => res && this['m_tool/deleteTool'](this.editedItem))
    },

    close() {
      this.$refs.form.resetValidation()
      this.dialog = false
      this.resetEntity()

      this['m_tool/fetchNextMaxCode']();
    },

    save() {
      let data = {
        toolCode: this.editedItem.toolCode,
        description: this.editedItem.description
      }

      if (~this.editedIndex) {
        data.id = this.editedItem.id
        this['m_tool/updateTool'](data)
      }

      if (!~this.editedIndex) {
        this['m_tool/createTool'](data)
      }

      this.close()
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.mHideLongLoader()
    })
  }
}
</script>

<style>
#toolTable {
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  width: auto;
  height: auto;
}
#toolTable header {
  font-weight: bold;
}
#toolsCard {
  width: auto;
}
</style>